// TeamSection.jsx
import React from 'react';
import {
  Box,
  Typography,
  Avatar,
  Tabs,
  Tab,
  Grid,
  Paper,
} from '@mui/material';

import vipin from '../assets/images/Teams/LeaderShip/vipin.png';
import naveen from '../assets/images/Teams/LeaderShip/naveen.png';
import nath from '../assets/images/Teams/LeaderShip/nath.png';
import shital from '../assets/images/Teams/LeaderShip/shital.png';
import bgPal from '../assets/images/Teams/LeaderShip/BG.png';
import sabya from '../assets/images/Teams/LeaderShip/sabya.png';
import mourizo from '../assets/images/Teams/LeaderShip/maurizo.png';
import gregory from '../assets/images/Teams/LeaderShip/gregory.png';
import amit from '../assets/images/Teams/LeaderShip/amit.png';
import banashree from '../assets/images/Teams/LeaderShip/banashree.png';

import anil from '../assets/images/Teams/Advisory/anil.png';
import balram from '../assets/images/Teams/Advisory/balram.png';
import charlotte from '../assets/images/Teams/Advisory/charlotte.png';
import denis from '../assets/images/Teams/Advisory/denis.png';
import frank from '../assets/images/Teams/Advisory/frank.png';
import leopold from '../assets/images/Teams/Advisory/leopold.png';
import michael from '../assets/images/Teams/Advisory/michael.png';
import rifat from '../assets/images/Teams/Advisory/rifat.png';
import ruchi from '../assets/images/Teams/Advisory/ruchi.png';
import sriram from '../assets/images/Teams/Advisory/sriram.png';



const leadershipTeam = [
  {
    name: 'Vipin Yadav',
    role: 'Founder and CEO',
    image: vipin,
  },
  {
    name: 'Naveen Narale',
    role: 'Global Delivery Head',
    image: naveen,
  },
  {
    name: 'Nath Narale',
    role: 'Head of Innovations',
    image: nath,
  },
  {
    name: 'Shital Thakkar',
    role: 'Head of Enterprise Business Solutions',
    image: shital,
  },
  {
    name: 'BG Pal',
    role: 'Head of Data Science and Analytics',
    image: bgPal,
  },
  {
    name: 'Sabyasachi Das',
    role: 'Head of Strategic Partnerships',
    image: sabya,
  },
  {
    name: 'Maurizio Becherle',
    role: 'Head of Operations, Switzerland',
    image: mourizo,
  },
  {
    name: 'Dr. Gregory Ashefor',
    role: 'Country Director, Nigeria',
    image: gregory,
  },
  {
    name: 'Amit Yadav',
    role: 'Head of Operations, India',
    image: amit,
  },
  {
    name: 'Banashree Basu',
    role: 'Head of Human Resources',
    image: banashree,
  },
];

const advisoryTeam = [
{
    name: 'Dr. Balram Bhargava',
    role: 'Ex-Director General ICMR',
    image: balram,
  },
  {
    name: 'Dr. Anil Purohit',
    role: 'Ex US govt.',
    image: anil,
  },
  {
    name: 'Dr. Rifat Atun',
    role: 'Vice Dean, Harvard University',
    image: rifat,
  },
  {
    name: 'Dr. Denis Braun',
    role: 'Ex-Executive Director of UnitAID',
    image: denis,
  },
  {
    name: 'Dr. Ruchi Dana ',
    role: 'Middle East & Africa Expert',
    image: ruchi,
  },
  {
    name: 'Prof. Michael Hedegaard',
    role: 'Prof. Denmark Technical University',
    image: michael,
  },
  {
    name: 'Sriram Yarlagadda',
    role: 'Venture Capatilist',
    image: sriram,
  },
  {
    name: 'Frank Lichner',
    role: 'CEO, Theon Data',
    image: frank,
  },
  {
    name: 'Dr. Leopold Zekenze ',
    role: 'Director of UNAIDS Nigeria',
    image: leopold,
  },
  {
    name: 'Charlotte Gloerfelt-Tarp',
    role: 'Vitafi Denmark',
    image: charlotte,
  },
];

const Team = () => {
  const [activeTab, setActiveTab] = React.useState(0);

  return (
    <Box sx={{ backgroundColor: '#0A1A45', py: 6, px: { xs: 2, md: 8 } }} className="teamSection">
      <Paper
        elevation={3}
        sx={{
          borderRadius: 4,
          px: { xs: 2, md: 6 },
          py: 4,
          backgroundColor: '#2E3B5C',
        }}
      >
        {/* Heading */}
        <Typography
          variant="h5"
          sx={{ color: 'white', textAlign: 'center', fontWeight: 'bold', mb: 4 }}
        >
          THE TEAM
        </Typography>

        {/* Tabs */}
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          centered
          TabIndicatorProps={{
            style: {
              backgroundColor: '#FFD700',
              height: 3,
              borderRadius: 2,
            },
          }}
          className='teamTabsContainer'
        >
          <Tab
            label="Leadership Team"
            sx={{
              color: activeTab === 0 ? '#FFD700' : '#fff',
              fontWeight: 'bold',
              textTransform: 'none',
            }}
          />
          <Tab
            label="Advisory Board"
            sx={{
              color: activeTab === 1 ? '#FFD700' : '#fff',
              fontWeight: 'bold',
              textTransform: 'none',
            }}
          />
        </Tabs>

        {/* Tab Content */}
        <Box sx={{ mt: 4 }}>
          {activeTab === 0 && (
            <div className='teamsMainSection'>
              {leadershipTeam.map((member, index) => (
                <div className='teamSections' key={index}>
                  <Box
                    sx={{
                      textAlign: 'center',
                    }}
                  >
                    <Avatar
                      src={member.image}
                      alt={member.name}
                      sx={{
                        width: 80,
                        height: 80,
                        mx: 'auto',
                        mb: 1.5,
                        // border: '3px solid #FFD700',
                      }}
                    />
                    <Typography
                      variant="subtitle2"
                      sx={{ color: '#c170ff', fontWeight: 'bold' , letterSpacing:'0.69px' }}
                    >
                      {member.name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#eee' }}>
                      {member.role}
                    </Typography>
                  </Box>
                </div>
              ))}
            </div>
          )}

          {activeTab === 1 && (
            // <Typography
            //   variant="body1"
            //   sx={{ textAlign: 'center', color: '#ccc', mt: 2 }}
            // >
            //   Advisory Board members coming soon.
            // </Typography>
            <div className='teamsMainSection'>
              {advisoryTeam.map((member, index) => (
                <div className='teamSections' key={index}>
                  <Box
                    sx={{
                      textAlign: 'center',
                    }}
                  >
                    <Avatar
                      src={member.image}
                      alt={member.name}
                      sx={{
                        width: 80,
                        height: 80,
                        mx: 'auto',
                        mb: 1.5,
                        // border: '3px solid #FFD700',
                      }}
                    />
                    <Typography
                      variant="subtitle2"
                      sx={{ color: '#c170ff', fontWeight: 'bold' , letterSpacing:'0.69px' }}
                    >
                      {member.name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#eee' }}>
                      {member.role}
                    </Typography>
                  </Box>
                </div>
              ))}
            </div>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default Team;
